export default "__VITE_ASSET__1$opp0pL__"